import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { useOrganizationCurrency } from "./use-organization-currency";

/**
 * Hook to get a project's currency
 * Returns the project's currency if set, otherwise falls back to organization currency
 * Defaults to 'EUR' if neither is available
 */
export function useProjectCurrency(projectId: string | null | undefined) {
  const orgCurrency = useOrganizationCurrency();

  const { data: projectResponse } = useQuery({
    queryKey: ["/api/projects", projectId, "light"],
    queryFn: async () => {
      if (!projectId) return null;
      const res = await apiRequest(`/api/projects/${projectId}?light=1`);
      return await res.json();
    },
    enabled: !!projectId,
    staleTime: 60_000, // Cache for 1 minute
    retry: false,
  });

  const project = (projectResponse as any)?.data || null;
  const projectCurrency = project?.currency;

  // Return project currency if set, otherwise fall back to organization currency
  return projectCurrency || orgCurrency || 'EUR';
}

